import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { initialDataList } from '@interfaces/common/common.Interface'

export interface DonTuState {
  donTuList?: any
  duyetDonList?: any
  nghiPhepList?: any
  lichLamViecList?: any
  quyTrinhDuyetList?: any
  reloadDonTuList?: string | null
}

const initialState: DonTuState = {
  donTuList: initialDataList,
  duyetDonList: initialDataList,
  nghiPhepList: initialDataList,
  lichLamViecList: initialDataList,
  quyTrinhDuyetList: initialDataList,
  reloadDonTuList: null,
}

export const donTuDucks = createSlice({
  name: 'donTu',
  initialState,
  reducers: {
    // Đơn từ
    layDanhSachDonTu: (state: RootState, action: PayloadAction<any>) => {
      state.donTuList = { loading: true, queryStr: action.payload }
    },
    layDanhSachDonTuThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.donTuList = { loading: false, ...action.payload }
    },
    layDanhSachDonTuThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.donTuList = { loading: false, ...action.payload }
    },

    // Duyệt đơn
    layDanhSachDuyetDon: (state: RootState, action: PayloadAction<any>) => {
      state.duyetDonList = { loading: true, queryStr: action.payload }
    },
    layDanhSachDuyetDonThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.duyetDonList = { loading: false, ...action.payload }
    },
    layDanhSachDuyetDonThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.duyetDonList = { loading: false, ...action.payload }
    },

    // Đơn nghỉ phép
    layDanhSachNghiPhep: (state: RootState, action: PayloadAction<any>) => {
      state.nghiPhepList = { loading: true, queryStr: action.payload }
    },
    layDanhSachNghiPhepThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.nghiPhepList = { loading: false, ...action.payload }
    },
    layDanhSachNghiPhepThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.nghiPhepList = { loading: false, ...action.payload }
    },

    // Lịch làm việc
    layDanhSachLichLamViec: (state: RootState, action: PayloadAction<any>) => {
      state.lichLamViecList = { loading: true, queryStr: action.payload }
    },
    layDanhSachLichLamViecThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.lichLamViecList = { loading: false, ...action.payload }
    },
    layDanhSachLichLamViecThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.lichLamViecList = { loading: false, ...action.payload }
    },

    // Quy trình duyệt
    layDanhSachQuyTrinhDuyet: (state: RootState, action: PayloadAction<any>) => {
      state.quyTrinhDuyetList = { loading: true, queryStr: action.payload }
    },
    layDanhSachQuyTrinhDuyetThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.quyTrinhDuyetList = { loading: false, ...action.payload }
    },
    layDanhSachQuyTrinhDuyetThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.quyTrinhDuyetList = { loading: false, ...action.payload }
    },

    datTaiLaiDanhSachDonTu: (state: RootState) => {
      state.reloadDonTuList = String(Date.now())
    },
  },
})

export const {
  layDanhSachDonTu,
  layDanhSachDonTuThanhCong,
  layDanhSachDonTuThatBai,
  layDanhSachDuyetDon,
  layDanhSachDuyetDonThanhCong,
  layDanhSachDuyetDonThatBai,
  layDanhSachNghiPhep,
  layDanhSachNghiPhepThanhCong,
  layDanhSachNghiPhepThatBai,
  layDanhSachLichLamViec,
  layDanhSachLichLamViecThanhCong,
  layDanhSachLichLamViecThatBai,
  layDanhSachQuyTrinhDuyet,
  layDanhSachQuyTrinhDuyetThanhCong,
  layDanhSachQuyTrinhDuyetThatBai,
  datTaiLaiDanhSachDonTu,
} = donTuDucks.actions

export default donTuDucks.reducer
